import { Box, TextField, Typography } from '@mui/material';
import {
  SettingsToggleRow,
  useConfigurationSectionSx,
} from 'components/@home/@settings/Tabs/Agents/panels/configurationSectionStyles';
import { func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const GreetingCard = ({ draft, onPatch }) => {
  const sx = useConfigurationSectionSx();
  const staticDisabled = Boolean(draft.disableInitialMessage);

  return (
    <Box sx={[sx.section, sx.card]}>
      <Typography sx={sx.sectionTitle}>{I18n.t('AgenticChatFlow.GreetingTitle')}</Typography>
      <Box sx={sx.sectionDivider} />
      <SettingsToggleRow
        label={I18n.t('AgenticChatFlow.DisableInitialMessage')}
        checked={Boolean(draft.disableInitialMessage)}
        onChange={e => onPatch('disableInitialMessage', e.target.checked)}
      />
      <Typography sx={[sx.sectionHelper, { mt: 1, mb: 2 }]}>
        {I18n.t('AgenticChatFlow.DisableInitialMessageHelp')}
      </Typography>
      <Box sx={sx.fieldsStack}>
        <Box>
          <Typography sx={sx.fieldLabel}>{I18n.t('AgenticChatFlow.GreetingChat')}</Typography>
          <TextField
            value={draft.initialMessages?.chat || ''}
            onChange={e =>
              onPatch('initialMessages', {
                ...draft.initialMessages,
                chat: e.target.value,
              })
            }
            fullWidth
            size="small"
            multiline
            minRows={2}
            disabled={staticDisabled}
            placeholder={I18n.t('AgenticChatFlow.GreetingChatPlaceholder')}
          />
        </Box>
        <Box>
          <Typography sx={sx.fieldLabel}>{I18n.t('AgenticChatFlow.GreetingVoice')}</Typography>
          <TextField
            value={draft.initialMessages?.voice || ''}
            onChange={e =>
              onPatch('initialMessages', {
                ...draft.initialMessages,
                voice: e.target.value,
              })
            }
            fullWidth
            size="small"
            multiline
            minRows={2}
            disabled={staticDisabled}
            placeholder={I18n.t('AgenticChatFlow.GreetingVoicePlaceholder')}
          />
        </Box>
      </Box>
    </Box>
  );
};

GreetingCard.propTypes = {
  draft: object.isRequired,
  onPatch: func.isRequired,
};

export default GreetingCard;
